export const MNP_EFFECTIVE_TIME_SLOT = [
  {
    title: "1am - 4am",
    value: "am",
  },
  {
    title: "12noon - 2pm",
    value: "pm",
  },
];